import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';

/**
 * One per-queue count on the admin billing dashboard: a link into that
 * organization's queue when the server reported a count, and a plain dash
 * when it did not (GDN-4023). Never a fabricated 0 — see `reportedCount`.
 */
export function QueueCountCell({
  count,
  emphasis = false,
  label,
  organizationName,
  to,
}: {
  /** The reported count, or null when the server sent none. */
  count: number | null;
  /** Claims to fix reads in the error colour, as it always has. */
  emphasis?: boolean;
  label: string;
  organizationName: string;
  to: string;
}) {
  if (count == null) {
    return (
      <>
        <span aria-hidden className="text-gray-400">
          —
        </span>
        <span className="sr-only">{`${label} not reported for ${organizationName}`}</span>
      </>
    );
  }
  return (
    <Button
      component={RouterLink}
      to={to}
      onClick={event => event.stopPropagation()}
      onAuxClick={event => event.stopPropagation()}
      size="small"
      color={emphasis ? 'error' : 'inherit'}
      aria-label={`${label} ${count} for ${organizationName}`}
    >
      {count}
    </Button>
  );
}
